import { Component, Input } from '@angular/core';
import { ClientTaskHistoryItem } from 'app/core/models/client-task-history-item.model';
import { ClientTaskHistoryItemTitleComponent } from '../client-task-history-item-title/client-task-history-item-title.component';
import { ClientTaskHistoryItemBodyComponent } from '../client-task-history-item-body/client-task-history-item-body.component';

@Component({
    selector: 'app-client-task-history-item-type-base',
    templateUrl: './client-task-history-item-type-base.component.html',
    imports: [ClientTaskHistoryItemTitleComponent, ClientTaskHistoryItemBodyComponent]
})
export class ClientTaskHistoryItemTypeBaseComponent {
  @Input() clientTaskHistoryItem: ClientTaskHistoryItem;

  constructor() {}

  // This is meant as fallback text and shouldn't be shown in practice
  get title() {
    return `Event: ${this.clientTaskHistoryItem.action}`;
  }

  get description() {
    return '';
  }

  get username() {
    return this.clientTaskHistoryItem.user.username;
  }

  get taskName() {
    switch(this.clientTaskHistoryItem.clientTaskType) {
      case 'ClientReferralTask': {
        return 'Referral';
      }
      case 'ClientConsultNoteTask': {
        return 'Consult Note';
      }
      case 'ClientPrescriberTask': {
        return 'Prescriber';
      }
      default: {
        return 'Unknown'
      }
    }
  }

  get choice() {
    return this.clientTaskHistoryItem.data.choice;
  }
}
